import React from 'react';
import { Link } from 'react-router-dom';
import { Link as MuiLink, Typography } from '@mui/material';
import usePermission from 'hooks/usePermission';
import { encriptId } from 'utils/encription';

function PatientLink({ name, id }) {
    const { hasPermission } = usePermission();

    return (
        <Typography variant="body1">
            {hasPermission(['patient_edit']) && id ? (
                <MuiLink component={Link} to={`/edit-patient/${encriptId(id)}`} underline="none" target="_blank">
                    <Typography noWrap>{name}</Typography>
                </MuiLink>
            ) : (
                <Typography variant="body1">{name}</Typography>
            )}
        </Typography>
    );
}

export default PatientLink;
